import { parseName } from "@certn/utils";

import { IconPersonAvatar } from "./IconPersonAvatar";
import { ImageAvatar } from "./ImageAvatar";
import { TextAvatar } from "./TextAvatar";
import { AvatarProps } from "./types";
import { Skeleton } from "../../patterns/skeleton/Skeleton";

export type { AvatarProps };

export function Avatar(props: AvatarProps) {
  const { name, image, isLoading, ...avatarBaseProps } = props;

  if (isLoading) {
    return <Skeleton isAvatar size={avatarBaseProps.size} />;
  }

  if (image) {
    return (
      <ImageAvatar
        image={<img src={image} alt="Avatar" />}
        {...avatarBaseProps}
      />
    );
  }

  if (name) {
    return (
      <TextAvatar
        name={typeof name === "string" ? parseName(name) : name}
        {...avatarBaseProps}
      />
    );
  }

  return <IconPersonAvatar {...avatarBaseProps} />;
}
